

import { DisabledPrompt, useRouteData, useStateManager } from "@bcm-dev/bcms-vite";

import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import InfoAlertView from "components/shared/views/InfoAlertView";
import { PrimaryButton, SecondaryButton } from "components/ui";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


export default function TASPositivePayImportChecksFileImportForm(props) {
    const { data, ui } = useStateManager();
    const { route } = useRouteData();
    const newTemplate = route ? route.newTemplate : undefined;
    const showNewTemplateBanner = newTemplate ? true : false;
    const templates = data.templates;
    const selectItems = templates.reduce((acc, item, index) => {
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id }>{ item.name }</CustomSelectItem>
        );
        return acc;
    }, [<CustomSelectItem key="none" className="none" value="none">None</CustomSelectItem>]);

    if(route) {
        window.history.replaceState({}, document.title);
    }

    return (
        <div className="tas-positive-pay-import-checks-form">
            <div className="flex-container flex-horizontal">
                { showNewTemplateBanner &&
                <InfoAlertView className="set-width checkmark-icon" text={ `You have successfully created ${ newTemplate._name }.` }
                    icon={ <SVGAsset id="CircleCheckmarkIcon" /> }/> 
                }
                { !showNewTemplateBanner && 
                <InfoAlertView className="set-width" text="You need to create a template before importing checks."
                    icon={ <SVGAsset id="InfoIcon" /> }/>
                }
            </div>
            <FormContainer className="small-form-width">
                <FormRowView text="Choose Template">
                    <CustomSelect active={ ui.chooseTemplateSelect.isActive } value="none">
                        { selectItems }
                    </CustomSelect>
                </FormRowView>
                <FormRowView text="File">
                    <div className="flex-container flex-horizontal align-center choose-file-container">
                        <DisabledPrompt>
                            <SecondaryButton text="Choose File"  />
                        </DisabledPrompt>
                        <p className="set-width no-file-chosen-text">{ `No file chosen` }</p>
                    </div>
                </FormRowView>
                <FormRowView>
                    <p>Maximum file size: 500 KB</p>
                    <p>Valid file extensions: .csv, .txt</p>
                </FormRowView>
                <FormButtonRow>
                    <DisabledPrompt>
                        <SecondaryButton text="Cancel"/>
                    </DisabledPrompt>
                    <DisabledPrompt>
                        <PrimaryButton className="disabled-button" text="Import" />
                    </DisabledPrompt>
                </FormButtonRow>
            </FormContainer>
        </div>
    );
}